<template>
	<van-config-provider theme="dark">
		<router-view v-if="isRouterActive"></router-view>
	</van-config-provider>
</template>

<script setup name="App">
	import { ref, provide, nextTick, getCurrentInstance, onMounted } from 'vue'
	import { useRouter } from 'vue-router'

	const { proxy } = getCurrentInstance(); 
	const router = useRouter();
	
	const isRouterActive = ref(true)
	provide('reload', () => {
	  isRouterActive.value = false
	  nextTick(() => {
	    isRouterActive.value = true
	  })
	})
	onMounted(() => {
		
	})
	
	
</script>

<style lang="less">
	body{
		background: #1f2122;font-size: 13px;color: #ffffff;
		font-family: 'Poppins', sans-serif!important;
	}
</style>
